import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	changeStatus: {
		id: 'bulk-operations-core.toolbar.use-status-action.change-status',
		defaultMessage: 'Change status',
		description:
			'The text will be shown inside a button in a toolbar to allow the user to edit the selected issues.',
	},
});
